import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { EndpointService } from '../../../../core/http/endpoint.service';

@Injectable()
export class ReviewDocumentDataService {
  constructor(private http: HttpClient,
              private toastr: ToastrService,
              private api: EndpointService) {}
  /**
   * servicio para descargar los archivos
   *
   * @param {number} idHistoryDocumento
   * @returns {Observable<any>}
   * @memberof ReviewDocumentDataService
   */
  dowloadFile(idHistoryDocumento: number): Observable<any> {
    return new Observable(obs => {
      this.http.skipErrorHandler()
        .get(this.api.get('historyDocsInstance', [idHistoryDocumento]), {
          observe: 'response'
        })
        .subscribe(
          res => {
              obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error['message'], 'Fallo de descarga');
            }
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/review-document/shared/review-document-data.service.ts